import React, { Component } from 'react';

class GoogleAds extends Component {

    componentDidMount() {
        (window.adsbygoogle = window.adsbygoogle || []).push({});    }

    render() {
        // console.log("google ads by me", this.props.slot);
        return (
            <ins className='adsbygoogle'
                 style={{ display: 'block' }}
                 data-ad-client= 'AW-696274611'
                 data-ad-slot={this.props.slot}
                 data-ad-format= 'auto'
                 data-full-width-responsive="true">
            </ins>
        );
    }
}

export default GoogleAds;



// WEBPACK FOOTER //
// ./src/components/Common/GoogleAds/GoogleAds.js